import Api from '../../../common/api/index'

const urlBaseWithoutToken = '/api/v1/bot/warehouses/warehouse_rentals/';
const urlBase = `${urlBaseWithoutToken}:warehouse_rental_token/`;

function buildUrlBase(token, url) {
  return (urlBase.replace(':warehouse_rental_token', token) + url)
}

function buildUrlWithoutTokenBase(url) {
  return (urlBaseWithoutToken + url)
}

export function loadCheckPrices(token) {
  return Api().get(buildUrlBase(token, ''))
}

export function sendDiscountCode(params) {
  return Api().post('/api/v1/bot/discount_codes', params)
}

export function loadItemsCategoryList(countryId = 0) {
  return Api().get(buildUrlWithoutTokenBase(`category_and_items/${countryId}`))
}

export function loadWarehouseListItems(token) {
  return Api().get(buildUrlBase(token, 'warehouse_list_items'))
}

export function getBlockedDates(countryId = 0) {
  return Api().get(buildUrlWithoutTokenBase(`next_dates_blocked/${countryId}`))
}

export function updateWarehouseRental(token, data) {
  return Api().put(buildUrlBase(token, ''), data);
}

export function updateItemsToRental(warehouseRentalId, data) {
  return Api().put( `/warehouses/${warehouseRentalId}/update_items_to_rental`, data);
}

export function getStateZoneInfo(desiredLocation) {
  return Api().get(
    `/warehouses/look_up_location`,
    { params: { desired_location: desiredLocation } }
  );
}

export function storageCenterUnavailable(storageCenterId, date, typeOfMovement, volume) {
  return Api().get(
    `/api/v1/warehouses/storage_centers/${storageCenterId}/unavailable`,
    {
      params: {
        type_of_movement: typeOfMovement,
        date: date,
        volume: volume
      }
    }
  )
}

export function loadClientDirection(token) {
  return Api().get(buildUrlBase(token, 'load_client_direction'));
}